'use client';

import { useEffect } from 'react';
import {
  browserEnv,
  keepHashTargetInView,
} from '@lib/keep-hash-target-in-view';

/**
 * Keeps a `#hash` link's target in view while embeds above it finish loading
 * and push it down the page. Runs once per full page load; client-side
 * navigations scroll through the Next router instead.
 */
const HashTargetKeeper = () => {
  useEffect(() => {
    if (typeof ResizeObserver === 'undefined') return undefined;
    return keepHashTargetInView(browserEnv());
  }, []);

  return null;
};

export default HashTargetKeeper;
